// prop-type is a library for typechecking of props
import PropTypes from "prop-types";

import debounce from "lodash.debounce";

// formik components
import { ErrorMessage, Field } from "formik";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftSelect from "components/SoftSelect";

function FormField({ options = [], forWhat = "", label = "", name = "", defaultValue = {}, menuPlacement, ...rest }) {
   return (
      <SoftBox>
         {forWhat === "Add Role" ? (
            <SoftBox mb={1.5}>
               {label && (
                  <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                     <SoftTypography component="label" variant="caption" fontWeight="bold" textTransform="capitalize">
                        {label}
                        {rest.required && <span style={{ color: "rgb(255, 102, 124)" }}> *</span>}
                     </SoftTypography>
                  </SoftBox>
               )}
               <Field {...rest} name={name} as={SoftInput} />
               <SoftBox mt={0.75}>
                  <SoftTypography component="div" variant="caption" color="error">
                     <ErrorMessage name={name} />
                  </SoftTypography>
               </SoftBox>
            </SoftBox>
         ) : (
            <SoftBox mb={1.5}>
               <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                  <SoftTypography component="label" variant="caption" fontWeight="bold" textTransform="capitalize">
                     {label}
                     {rest.required && <span style={{ color: "rgb(255, 102, 124)" }}> *</span>}
                  </SoftTypography>
               </SoftBox>
               <Field name={name}>
                  {({ field, form }) => {
                     const debouncedValidate = debounce(() => {
                        form.validateField(field.name);
                     }, 100);
                     return (
                        <SoftSelect
                           defaultValue={defaultValue}
                           options={options}
                           onChange={({ value }) => {
                              form.setFieldValue(field.name, value);
                              debouncedValidate();
                           }}
                           onBlur={() => {
                              form.setFieldTouched(field.name, true);
                           }}
                           menuPlacement={menuPlacement ?? "auto"}
                        />
                     );
                  }}
               </Field>
               <SoftBox mt={0.75}>
                  <SoftTypography component="div" variant="caption" color="error">
                     <ErrorMessage name={name} />
                  </SoftTypography>
               </SoftBox>
            </SoftBox>
         )}
      </SoftBox>
   );
}

// typechecking props for FormField
FormField.propTypes = {
   label: PropTypes.string.isRequired,
   name: PropTypes.string.isRequired,
   options: PropTypes.arrayOf(PropTypes.object),
   forWhat: PropTypes.string,
   defaultValue: PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.string
   })
};

export default FormField;
